// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__2Le_d","footnote":"Page_footnote__2AV31","separator":"Page_separator__GAOrD"};